import { useState } from 'react'
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";

// import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
// import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
// import TimePicker from '@material-ui/lab/TimePicker';

import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Button } from '../../../components/button'
import { AssignmentButtonWrapper, TableWrapper } from '../../../styles/assignment/assignment';
import { Link } from 'react-router-dom';
import { Table } from '../../../components/table/table';
import { TableData } from '../../../services/tableData';
// import { RowDots } from "../../../components/table/row-menu";


const ExaminationView = () => {

    const columns = [
        {
            name: "Name",
            selector: (row) => row.name,
        },
        {
            name: "Class",
            selector: (row) => row.class,
        },
        {
            name: "Date Submitted",
            selector: (row) => row.dateSubmitted,
        },
        {
            name: "Score",
            selector: (row) => row.score,
        },
        {
            name: "Date Scored",
            selector: (row) => row.dateScored,
        },
        {
            name: "Grade",
            selector: (row) => row.grade,
        },
        // {
        //     name: "",
        //     selector: (row) => row.address,
        //     width: "50px",
        //     cell: () => {
        //         return (
        //             <RowDots
        //                 options={["Edit school", "Feature"]}
        //             // optionsFns={[() => router.push(`edit`)]}
        //             />
        //         );
        //     },
        // },
    ];

    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Examination
                        </Heading>
                        <Breadcrumb
                            crumbs={['Examination', "mathematics"]}
                        />
                        <div style={{ marginTop: '8.7rem' }}>
                            <AssignmentButtonWrapper>
                                {/* <Link to='/teacher/assignments/upload'> */}
                                <Button>UPLOAD SOLUTION</Button>
                                {/* </Link> */}
                                <Button variant="secondary">DOWNLOAD</Button>
                            </AssignmentButtonWrapper>
                            <TableWrapper>
                                <Table
                                    columns={columns}
                                    data={TableData || []}
                                />
                            </TableWrapper>
                        </div>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper >
    )
}

export default ExaminationView
